import React from 'react'

const DEFAULT_PREFIX = 'glyphicon'

export default ({ icon, title, className, prefix = DEFAULT_PREFIX }) => (
    <span className={`${prefix} ${prefix}-${icon} ${className || ''}`} title={title} />
)


// WEBPACK FOOTER //
// ./components/Icon.jsx